<div class="df-modal">
  <!-- Header -->
  <div class="df-modal__header" [ngClass]="statusConfig.cssClass">
    <div class="df-modal__header-icon">
      <mat-icon>{{ statusConfig.icon }}</mat-icon>
    </div>
    <div class="df-modal__header-text">
      <h2 class="df-modal__title">{{ form.title || statusConfig.title }}</h2>
      <p class="df-modal__meta">
        Form #{{ form.id }}@if (form.status === 'submitted' && form.submitted_at) {
        &nbsp;&bull;&nbsp;Submitted
        {{ form.submitted_at | convertToLocalTime : 'DD/MM/YYYY h:mm A' }}
        }
      </p>
    </div>
    <span class="df-modal__badge">
      <mat-icon style="font-size: 14px; height: 14px; width: 14px">{{
        statusConfig.icon
      }}</mat-icon>
      {{ statusConfig.badge }}
    </span>
    <button mat-icon-button class="df-modal__close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="df-modal__body">
    @for (question of form.questions; track question) {
    <div class="df-modal__row">
      <p class="df-modal__label">
        {{ question.label }}@if (question.required) {
        <span class="df-modal__required" title="Required">*</span>
        }
      </p>
      <div class="df-modal__value">
        <!-- Booking slot type -->
        @if (question.type === 'booking_slot') { @if
        (isBookingSlotAnswer(getAnswer(question.id))) {
        <span class="df-booking-slot">
          <mat-icon class="df-booking-slot__icon">event</mat-icon>
          {{ formatBookingSlot(getAnswer(question.id)) }}
        </span>
        } @else {
        <span class="df-modal__empty">Not answered</span>
        } } @else { @if (question.type === 'consent' || question.type ===
        'confirm_delivery_address') { @if (getAnswer(question.id) !== null &&
        getAnswer(question.id) !== undefined) {
        <span
          class="df-consent"
          [class.df-consent--confirmed]="isConsentConfirmed(getAnswer(question.id))"
          [class.df-consent--declined]="!isConsentConfirmed(getAnswer(question.id))"
        >
          <mat-icon class="df-consent__icon">{{
            isConsentConfirmed(getAnswer(question.id)) ? 'check_circle' : 'cancel'
          }}</mat-icon>
          {{ formatConsentAnswer(getAnswer(question.id)) }}
        </span>
        } @else {
        <span class="df-modal__empty">Not answered</span>
        } } @else { @if (question.type === 'file') { @if (isFileAnswer(getAnswer(question.id)))
        { @for (doc of asFileAnswers(getAnswer(question.id)); track doc) { @if (doc.url) {
        <a
          [href]="doc.url"
          target="_blank"
          rel="noopener"
          class="df-doc-chip df-doc-chip--link"
        >
          <mat-icon class="df-doc-chip__icon">insert_drive_file</mat-icon>
          {{ doc.name || 'Document #' + doc.id }}
        </a>
        } @if (!doc.url) {
        <span class="df-doc-chip">
          <mat-icon class="df-doc-chip__icon">insert_drive_file</mat-icon>
          {{ doc.name || 'Document #' + doc.id }}
        </span>
        } } } @else {
        <span class="df-modal__empty">Not answered</span>
        } } @else { @if (isStringArrayAnswer(getAnswer(question.id))) { @if
        (asStringArray(getAnswer(question.id)).length > 0) { @for (item of
        asStringArray(getAnswer(question.id)); track item) {
        <span class="df-tag">{{ item }}</span>
        } } @else {
        <span class="df-modal__empty">Not answered</span>
        } } @else { @if (asTextAnswer(getAnswer(question.id))) {
        <span class="df-modal__answer">
          {{ asTextAnswer(getAnswer(question.id)) }}
        </span>
        } @else {
        <span class="df-modal__empty">Not answered</span>
        } } } } }
        <!-- Consent / delivery address confirmation type -->
        <!-- File type -->
        <!-- Text / textarea / radio / date / number -->
      </div>
    </div>
    }
  </div>

  <!-- Footer -->
  <div class="df-modal__footer">
    <div class="df-modal__timestamps">
      <span
        ><b>Created:</b> {{ form.created_at | convertToLocalTime : 'DD/MM/YYYY h:mm A' }}</span
      >
      <span
        ><b>Updated:</b> {{ form.updated_at | convertToLocalTime : 'DD/MM/YYYY h:mm A' }}</span
      >
    </div>
    <button mat-stroked-button (click)="close()">Close</button>
  </div>
</div>
